import type { ExamTypeConfig } from '@examflow/core';
import { registerExamQuestionTypes } from '@examflow/core';
import { TCF_SECTIONS } from './sections';
import { tcfScoringRules } from './scoring';
import { TCF_QUESTION_TYPE_DEFINITIONS } from './questionTypes';

/**
 * TCF 考试完整配置
 */
export const tcfExamConfig: ExamTypeConfig = {
  id: 'tcf',
  name: 'TCF (Test de Connaissance du Français)',
  description:
    'TCF 是法国教育部认可的法语水平测试，评估非法语母语者的法语能力。',
  languageId: 'french',
  // 考试特定的题目类型定义
  questionTypeDefinitions: TCF_QUESTION_TYPE_DEFINITIONS,
  sections: TCF_SECTIONS,
  scoringRules: tcfScoringRules,
};

// 注册 TCF 的题目类型定义到全局注册表
registerExamQuestionTypes('tcf', Object.values(TCF_QUESTION_TYPE_DEFINITIONS));

// 导出 TCF 特定类型和工具函数
export * from './types';
export * from './sections';
export * from './scoring';
export * from './levels';
export * from './intro';
export * from './questionTypes';
